module.exports = __webpack_public_path__ + "img/4.730319e4.svg";